import {
  Component,
  Input,
  QueryList,
  ViewChildren
} from '@angular/core';
import { ZefFormElementDirective } from '@zerops/zef/forms';
import { AutoscalingProfile, ServiceStackTypes } from '@zerops/models/service-stack';
import { ServiceStackHorizontalAutoscaling, ServiceStackVerticalAutoscaling } from '@zerops/models/settings';
import { LocalStorageServiceStackFormTranslations } from './local-storage-service-stack-form.translations';

@Component({
  selector: 'z-local-storage-service-stack-form',
  templateUrl: './local-storage-service-stack-form.component.html',
  styleUrls: [ './local-storage-service-stack-form.component.scss' ]
})
export class LocalStorageServiceStackFormComponent {
  @Input()
  state: any;

  @Input()
  serviceStackType: ServiceStackTypes;

  @Input()
  isZen: boolean;

  @Input()
  /** Value assigned in {@link ServiceStackAddFormContainer} */
  defaultHorizontalAutoscaling: ServiceStackHorizontalAutoscaling;

  @Input()
  /** Value assigned in {@link ServiceStackAddFormContainer} */
  defaultVerticalAutoscaling: ServiceStackVerticalAutoscaling;

  @Input()
  /** Value assigned in {@link ServiceStackAddFormContainer} */
  verticalPlaceholder: ServiceStackVerticalAutoscaling;

  @Input()
  /** Value assigned in {@link ServiceStackAddFormContainer} */
  horizontalPlaceholder: ServiceStackHorizontalAutoscaling;

  @Input()
  /** Value assigned in {@link ServiceStackAddFormContainer} */
  supportsVerticalAutoscaling = true;

  @Input()
  autoscalingProfiles: AutoscalingProfile[] = [];

  @Input()
  isFreeUser = false;

  @Input()
  translations: LocalStorageServiceStackFormTranslations;

  @ViewChildren(ZefFormElementDirective)
  formElementsRefs: QueryList<ZefFormElementDirective>;
}
